var React = require('react');

function FilledArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 36C27.941 36 36 27.9412 36 18C36 8.05888 27.941 0 18 0C8.05887 0 0 8.05888 0 18C0 27.9412 8.05887 36 18 36Z","fill":"#281E78","key":0}),React.createElement("path",{"d":"M10.5 15L18 22.5L25.5 15","stroke":"#FCFCFC","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

FilledArrow.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = FilledArrow;

FilledArrow.default = FilledArrow;
